import React, {useEffect, useCallback, useState} from 'react';
import {searchPacks} from "components/packs/searchPacks.js";
import {searchPresets} from 'decentralized/presets/PresetsSearcher.js';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';

let counter=0;
export const usePresets = ({
    type,
    guildId,
    filterFavorites,
    track,
    searchTerm,
    groupByPacks,
    setGroupByPacks,
}) => {
    const [searchTermExecuted, setSearchTermExecuted] = useState(undefined);
    const [presetsByPack, setPresetsByPack] = useState([]);
    const [presets, setPresets] = useState([]);
    const [tags, setTags] = useState([]);
    const [instrumentType, setInstrumentType] = useState(type);

    if (instrumentType && (instrumentType.startsWith("zobject") || instrumentType === "formants")) {
        groupByPacks = false;
    }

    useEffect(() => {
        if (type.startsWith("zobject") || type === "formants") {
            setGroupByPacks(false);
        }
    }, [type]);

    useEffect(() => {
        if (type === MULTI_SYNTH) {
            let tags = ["bass", "bells", "drums", "flute", "guitar", "keys", "lead", "organ", "pad", "piano", "pluck", "stab", "strings"];
            setTags(tags);
        } else {
            let tags = ["bass", "flute", "korg", "keys", "moog", "pad", "prophet", "piano", "vibraphone"];
            setTags(tags);
        }
    }, [setTags, type]);

    useEffect(() => {
        if (groupByPacks) {
            let _counter = (++counter);
            setTimeout(() => {
                if (_counter !== counter) {
                    return;
                }
                searchPacks(searchTerm, true, "PRESET").then(
                    results => {
                        if (_counter !== counter) {
                            return;
                        }
                        setSearchTermExecuted(searchTerm);
                        let names = {};
                        for (let x of results) {
                            names[x.title] = x;
                        }
                        setPresetsByPack(Object.keys(names).map(n => names[n]));
                    });
            }, 200);
        } 
   }, [
        searchTerm,
        setSearchTermExecuted,
        setPresetsByPack,
        groupByPacks,
        setPresets,
        instrumentType,
        filterFavorites,
        guildId]);

    useEffect(() => {
        let unmounted = false;
        if (!groupByPacks) {
            // NOTE: synths from pre 8359897 block are broken since they refer
            // to an old version of the synth
            console.log("searching presets by instrumentType =", instrumentType);
            searchPresets(
                undefined,
                instrumentType,
                [],
                guildId,
                instrumentType===MULTI_SYNTH ? 8359897 : undefined,
                filterFavorites
            )
                .then(x => {
                    if (!unmounted) {
                        if (track) {
                            track.browsedPresets = x;
                        }
                        setPresets(x);
                    }
                });
        }
        return () => unmounted = true;
    }, [
        filterFavorites,
        instrumentType,
        setPresets,
        guildId,
        groupByPacks]);

    useEffect(() => {
        setInstrumentType(type);
    }, [type, setInstrumentType]);


    return {
        presetsByPack,
        presets,
        instrumentType,
        tags,
        setInstrumentType,
        searchTermExecuted
    };
};
